import Raven from 'raven-js';
import I18n from 'I18n';
import { DATE_TIME } from 'customer-data-objects/property/PropertyTypes';
import MissingField from 'customer-data-filters-ui/filterQueryFormat/MissingField';
import { hasRemoveTimezoneForDates } from '../permissions/gates';
const UTC = 'UTC';
export const TIMEZONE_TYPES = {
  UTC,
  USER_TZ: 'USER_TZ',
  PORTAL_TZ: 'PORTAL_TZ'
};
export const getLocalZoneId = () => {
  // userTz().tz() would be best, but its undefined due to the way the moment object is created
  const momentUserTz = I18n.moment.userTz().tz();
  if (typeof momentUserTz !== 'undefined') {
    return momentUserTz;
  }
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch (err) {
    Raven.captureException(err);
  }
  return I18n.moment.tz.guess();
};
export const getPortalZoneId = () => {
  return I18n.moment.portalTz().tz();
};
export const getDefaultTimezone = field => {
  if (!field || MissingField.isMissingField(field)) {
    return undefined;
  }
  return field.get('type') === DATE_TIME ? getPortalZoneId() : UTC;
};
export const getDefaultTimezoneWithoutOptionality = field => {
  if (!field || MissingField.isMissingField(field)) {
    return undefined;
  }
  return getPortalZoneId();
};
export const getIsUTC = (condition, getIsUngated) => {
  const defaultTimezone = hasRemoveTimezoneForDates(getIsUngated) && !condition.hasTimezones ? getDefaultTimezoneWithoutOptionality(condition.field) : getDefaultTimezone(condition.field);
  const zoneId = condition.value ? condition.value.tz() || 'UTC' : defaultTimezone;
  return zoneId === 'UTC';
};